import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import {
  ControlContainer,
  FormArray,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import { ServiceDataFields } from '@app/modules/service-data/components/service-data/service-data-form/field-sets/service-data-fields.enum';
import { TranslatePipe } from '@ngx-translate/core';
import { RequirePermissionDirective } from '@shared/directives/require-permission.directive';
import { controlContainerProvider } from '@shared/helpers';
import {
  ParticipantField,
  ServiceDataFormParticipantComponent,
} from './service-data-form-participant/service-data-form-participant.component';

// Other test participants besides the patient (NIPPT alleged father,
// Paternity additional participants). Rendered inside `serviceInformation`.
@Component({
  selector: 'app-service-data-form-additional-participants',
  imports: [
    ReactiveFormsModule,
    TranslatePipe,
    RequirePermissionDirective,
    ServiceDataFormParticipantComponent,
  ],
  templateUrl: './service-data-form-additional-participants.component.html',
  viewProviders: [controlContainerProvider],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceDataFormAdditionalParticipantsComponent {
  private controlContainer = inject(ControlContainer);

  readonly fieldSet = input.required<string[]>();
  readonly id = input<string>();

  protected readonly ServiceDataFields = ServiceDataFields;
  protected readonly allegedFatherFields: ParticipantField[] = [
    'firstName',
    'lastName',
    'dateOfBirth',
    'email',
    'documentNumber',
    'phoneNumber',
    'ethnicity',
  ];
  protected readonly paternityParticipantFields: ParticipantField[] = [
    'firstName',
    'lastName',
    'dateOfBirth',
    'email',
    'gender',
    'relationship',
  ];

  protected get paternityParticipants() {
    return (this.controlContainer.control as FormGroup).get(
      'paternity.additionalParticipants'
    ) as FormArray<FormGroup>;
  }
}
